/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for ReceiptController controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_VERSUSCLIENT, CLIENT_CONTEXT_TOKEN_VERSUSCLIENT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { RequestOptions, PaymentResponseDto, PagedModelPaymentResponseDto } from "../models";

@Injectable({ providedIn: "root" })
export class ReceiptControllerService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_VERSUSCLIENT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_VERSUSCLIENT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'VersusClient');
    }

    getPaymentDetails(reference: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<PaymentResponseDto>;
    getPaymentDetails(reference: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<PaymentResponseDto>>;
    getPaymentDetails(reference: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<PaymentResponseDto>>;
    getPaymentDetails(reference: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/payments/receipts/${reference}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getDuplicata(reference: string, idPartner: number, page?: number, size?: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<PagedModelPaymentResponseDto>;
    getDuplicata(reference: string, idPartner: number, page?: number, size?: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<PagedModelPaymentResponseDto>>;
    getDuplicata(reference: string, idPartner: number, page?: number, size?: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<PagedModelPaymentResponseDto>>;
    getDuplicata(reference: string, idPartner: number, page?: number, size?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/payments/receipts/history`;

        let params = new HttpParams();
        if (reference != null) {
            params = HttpParamsBuilder.addToHttpParams(params, reference, 'reference');
        }
        if (idPartner != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idPartner, 'idPartner');
        }
        if (page != null) {
            params = HttpParamsBuilder.addToHttpParams(params, page, 'page');
        }
        if (size != null) {
            params = HttpParamsBuilder.addToHttpParams(params, size, 'size');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }
}
